import { DateService } from './date.service';
import { DateUtilsService } from './date-utils.service';

export function parseDateRange(
  dateRangeString: string,
  dateService: DateService,
  dateUtils: DateUtilsService
): { from: Date; to: Date } {
  let from = new Date(1800, 0, 1), to = new Date(3000, 0, 1);

  if (dateRangeString) {
    dateRangeString.replace(
      /^past$|^future$|^\[([+-]?)(\d+y)?(\d+m)?(\d+d)?,([+-]?)(\d+y)?(\d+m)?(\d+d)?]$/,
      function (m, fromDir, fromY, fromM, fromD, toDir, toY, toM, toD) {
        switch (m[0]) {
          case 'p':
            to = dateService.now();
            break;
          case 'f':
            from = dateService.now();
            break;
          default:
            const fromSign = fromDir === '-' ? -1 : 1;
            const toSign = toDir === '-' ? -1 : 1;
            const now = dateService.now();

            from = dateUtils.advanceDate(
              now,
              fromSign * parseInt(fromY || '0', 10),
              fromSign * parseInt(fromM || '0', 10),
              fromSign * parseInt(fromD || '0', 10)
            );

            to = dateUtils.advanceDate(
              now,
              toSign * parseInt(toY || '0', 10),
              toSign * parseInt(toM || '0', 10),
              toSign * parseInt(toD || '0', 10)
            );
            break;
        }
        return m;
      }
    );
  }

  return { from, to };
}
